import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin(() => {
    if (typeof window.oaiq === 'function') {
        return;
    }

    const oaiq = (...args: unknown[]) => {
        oaiq.q.push(args);
    };

    oaiq.q = [] as unknown[][];

    window.oaiq = oaiq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

    const firstScript = document.getElementsByTagName('script')[0];

    if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }

    oaiq('init', {
        pixelId: 'WBJWhVQ9QGPJudKJuuQowQ',
        // for testing OpenAI/Chatgpt change debug: false to debug: true
        debug: true,
    });
});